import React from 'react';
import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from '../Navigation/Sidebar';


const collapsedWidth = 64;

const AppLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      
      {/* Основной контент */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: isMobile ? 2 : 3,
          width: `calc(100% - ${collapsedWidth}px)`,
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          ml: `${collapsedWidth}px`,
          maxWidth: '100%',
          overflow: 'auto',
          bgcolor: 'grey.50',
          minHeight: '100vh',
        }}
      >
        <Container 
          maxWidth="xl" 
          sx={{ 
            p: 0,
            height: '100%',
          }}
        >
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export default AppLayout;
